import { Route } from 'react-router-dom';
import ListarCreditosComponente from './Listar-Creditos';
import Cobranza from './Cobranza';
import VisitaComponente from './Visita';

const CobranzaRouter = (
  <Route path="cobranza" element={<Cobranza />}>
    <Route path="creditos" element={<ListarCreditosComponente />} />
    <Route path=":id/visita" element={<VisitaComponente />} />
  </Route>
);

export default CobranzaRouter;
